export enum TabId {
  WITHDRAWAL = 'withdrawal',
}

export interface FormWithdrawalResponse {
  requestId: string;
}
